import React from 'react';

export const colorCellRender = ({ value }) => {
    return value ? (
        <span className="ag-color-picker color-picker">
            <i className="icon icon-circle2" style={{ color: value }} />
        </span>
    ) : (
        ''
    );
};
